// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5b-2";
export var blackBorderOnHover = "_5b-7";
export var cell = "_5b-6";
export var cellContainer = "_5b-3";
export var checked = "_5b-8";
export var disabled = "_5b-5";
export var featuredIconCellContainer = "_5b-9";
export var featuredIconTextContainer = "_5b-b";
export var featuredIconWrapper = "_5b-a";
export var noBorder = "_5b-c";
export var orangeSelectedRow = "_e9-3";
export var overflowableText = "_5b-0";
export var overflowableTextContainer = "_5b-1";
export var row = "_5c-0";
export var rowCheckboxCell = "_5b-4";
export var selectableTable = "_e9-2";